import { OverlayLoader } from '@core/PageLoader';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { appRoutes, type AppRouteConfig } from '../route';
import { ErrorBoundary } from './ErrorBoundary';
import { LazyLoadRoute } from './LazyLoadRoute';

function RouteFallback() {
  return <OverlayLoader message="Loading route" />;
}

function renderRoute(route: AppRouteConfig) {
  const children = route.children?.map(renderRoute);

  if (route.index) {
    return <Route key="index" index element={<LazyLoadRoute route={route} />} />;
  }

  return (
    <Route key={route.path} path={route.path} element={<LazyLoadRoute route={route} />}>
      {children}
    </Route>
  );
}

export default function AppRouter() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<RouteFallback />}>
        <Routes>{appRoutes.map(renderRoute)}</Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
